module.exports = function setupHooks(appInstance) {
    appInstance.hooks = {
        onRequest: [],
        preValidation: [],
        preHandler: [],
        onResponse: []
    };

    appInstance.addHook = function (name, handler) {
        if (this.hooks[name]) {
            this.hooks[name].push(handler);
        }
        return this;
    };

    appInstance.executeHooks = async function (name, req, res) {
        if (!this.hooks[name]) return;
        for (const hook of this.hooks[name]) {
            await hook(req, res);
        }
    };
};
